import React, { Component } from 'react'
import { findDOMNode } from 'react-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'
import * as instructorActions from '../../_actions/roster.actions'
import dates from 'react-big-calendar/lib/utils/dates'
import TimeGridHeader from './TimeGridHeader'
import TimeGutter from 'react-big-calendar/lib/TimeGutter'
import moment from 'moment'
import memoize from 'memoize-one'
import Resources from 'react-big-calendar/lib/utils/Resources'
import getWidth from 'dom-helpers/width'
import DayColumn from './DayColumn'


class ReportContents extends Component {
    constructor(props) {
        super(props)
        this.state = { gutterWidth: undefined, isOverflowing: null }
        this.gutterRef = React.createRef()
        this.scrollRef = React.createRef()
    }

    static defaultProps = {
        step: 60,
        timeslots: 1,
        min: dates.startOf(new Date(), 'day'),
        max: dates.endOf(new Date(), 'day'),
        scrollToTime: dates.startOf(new Date(), 'day'),
        getNow: () => new Date(),
    }

    componentDidMount = () => {
        this.measureGutter()

    }

    componentWillReceiveProps = () => {
        this.measureGutter()
    }

    measureGutter() {
        let node = findDOMNode(this.gutterRef.current)
        // let node = document.getElementById('timegutter')
        const width = getWidth(node)

        if (width && this.state.gutterWidth !== width) {
            this.setState({ gutterWidth: width })
        }
    }

    memoizedResources = memoize((resources, accessors) =>
        Resources(resources, accessors)
    )

    handleScroll = e => {
        if (this.scrollRef.current) {
            this.scrollRef.current.scrollLeft = e.target.scrollLeft
        }
    }

    renderEvents(range, events, now) {
        let { min, max, components, localizer } = this.props

        return range.map((date, jj) => {
            let daysEvents = (events || []).filter(
                event =>
                    dates.inRange(event.start, date, date, 'day') ||
                    dates.inRange(event.end, date, date, 'day')
            )

            return (
                <DayColumn
                    {...this.props}
                    localizer={localizer}
                    min={dates.merge(date, min)}
                    max={dates.merge(date, max)}
                    components={components}
                    isNow={dates.eq(date, now(), 'day')}
                    key={jj}
                    date={date}
                    daysEvents={daysEvents}
                />
            )
        })
    }

    render() {
        let { localizer, range, getNow } = this.props

        let start = range[0]

        let min = moment('12:00am', 'h:mma').toDate()
        let max = moment('11:59pm', 'h:mma').toDate()

        const eventsList = _.map(this.props.displayWorkEvents, (obj, key) => {
            return obj
        })

        return (
            <div>
                <div className="rbc-time-view reporting">
                    <TimeGridHeader
                        range={range}
                        localizer={localizer}
                        width={this.state.gutterWidth}
                        getNow={this.props.getNow}
                        scrollRef={this.scrollRef}
                        isOverflowing={true}
                    />

                    <div
                        ref="content"
                        className="rbc-time-content"
                        onScroll={this.handleScroll}
                    >
                        <TimeGutter
                            date={start}
                            ref={this.gutterRef}
                            localizer={localizer}
                            min={dates.merge(start, min)}
                            max={dates.merge(start, max)}
                            step={this.props.step}
                            getNow={this.props.getNow}
                            timeslots={this.props.timeslots}
                            components={<div />}
                            className="rbc-time-gutter"
                        />
                        {this.renderEvents(range, eventsList, getNow)}
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        // events: state.roster.displayWeeklyReportEvents,
        currentWeekDate: state.roster.currentWeekDate,
        displayWorkEvents: state.roster.displayWorkEvents,        
        employees: state.roster.employeeList,
        selectedEmployee: state.roster.selectedEmployee,
        branches: state.BranchReducer.branchList,
        departments: state.DepartmentReducer.departmentList,
        actionTypes: state.ActionTypesReducer.actionTypes,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(instructorActions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportContents)
